export default {
  search: {
    placeholder: "Search...",
    noResult: "No result found"
  },
  addSearchValue: "Add `{{value}}`",
  autoTitle: {
    fallback: "Select an option",
    noOptions: "No options available",
  }
}
